// src/pages/Mafia/mafiaPdfFont.js
//
// Loads the symbol font of the MAFIA PDFs (DejaVu Sans Condensed, free
// licence: src/assets/fonts/DejaVuSans-LICENSE.txt) once per visit. The file
// is fetched when a MAFIA print page is opened, so that it is there when the
// PDF is made; a PDF made without it uses the built-in font (mafiaPdfText.js).

import fontUrl from "../../assets/fonts/DejaVuSansCondensed.ttf";

let loaded = null;     // base64 of the font file
let loading = null;    // the fetch that is running

function toBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  const step = 0x8000;
  for (let i = 0; i < bytes.length; i += step)
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + step));
  return window.btoa(binary);
}

/** Resolves to the font (base64) or to null when it could not be loaded. Never rejects. */
export function loadPdfSymbolFont() {
  if (loaded) return Promise.resolve(loaded);
  if (!loading) {
    loading = fetch(fontUrl)
      .then((r) => (r.ok ? r.arrayBuffer() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then((buffer) => {
        loaded = toBase64(buffer);
        return loaded;
      })
      .catch((err) => {
        loading = null;   // asked for again next time
        console.warn("The symbol font of the MAFIA PDFs could not be loaded; the built-in font is used.", err);
        return null;
      });
  }
  return loading;
}

/** The font when it is loaded already, else null (for code that may not wait). */
export function loadedPdfSymbolFont() {
  return loaded;
}
